import request from '@/src/utils/request'

// 取得分店資料
export const getOrderShortUrl = async (uuid) => {
  const response = await request.get(`/admin/order/${uuid}/shortUrl`)
  return response
}
